import Filters from './filters'

export default class TypedFilters extends Filters {
  static getFilterType() {
    throw new TypeError('You must set filter type (plugin, theme etc.) for typed filters.')
  }
}
